<template>
  <div>
    <div class="banner">
      <svg width="787"
           height="143"
           viewBox="0 0 787 143"
           fill="none"
           class="banner__street"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M512.919 14.7471C520.124 20.4683 525.945 28.4206 528.375 37.5447C532.706 53.4747 526.765 71.1389 515.061 82.3925C508.159 88.4692 499.486 92.9315 490.627 95.3622C484.063 97.2342 476.133 98.0795 470.098 98.6055C465.887 99.0009 461.304 99.2767 458.354 99.7809C454.482 100.445 444.476 101.816 444.268 105.963C444.177 107.82 446.446 110.215 447.809 110.817C451.852 112.446 454.872 111.989 459.534 112.493C469.799 113.509 480.249 112.718 490.525 110.759C497.46 109.424 504.316 107.512 510.861 104.856C521.709 100.434 530.458 95.1989 536.046 85.3565C537.445 83.0129 538.996 79.9401 540.676 77.2881C544.267 71.3819 549.702 66.5605 556.473 64.449C562.251 62.646 567.897 62.3703 573.841 63.0922C581.753 64.0464 589.22 68.2583 594.225 74.208C597.266 77.6727 599.368 81.228 601.74 84.4749C603.335 86.6117 604.621 88.1754 606.624 89.4415C610.263 91.698 615.02 91.727 619.748 91.5783C625.544 91.386 630.727 90.1525 636.286 87.9504C643.276 85.1678 650.448 81.3005 657.733 78.3148C669.334 73.3954 682.131 70.3625 694.541 69.2778C703.859 68.4216 713.016 68.4361 722.181 68.944C729.542 69.2632 738.164 69.9163 743.187 76.2433C748.469 83.1544 746.251 91.3425 740.179 96.8424C736.671 100.071 732.861 102.248 728.573 104.084C720.848 107.015 712.881 108.252 705.046 110.324C699.732 111.753 687.329 114.699 684.56 119.382C684.171 120.162 684.378 121.026 684.753 121.791C685.668 123.797 687.154 125.223 689.175 126.384C696.541 130.288 705.895 129.664 714.127 129.312C726.668 128.978 739.148 128.731 751.602 127.291C763.356 125.931 775.198 125.042 787 124.298C779.198 125.437 771.399 126.616 763.644 127.966C755.852 129.305 748.145 131.028 740.302 132.145C731.95 133.357 723.601 134.249 715.249 135.142C707.508 135.944 699.994 136.709 692.162 135.062C687.631 134.075 683.1 132.123 679.909 128.419C675.662 123.522 674.955 117.532 679.439 112.624C686.68 104.849 703.884 101.207 713.989 98.1375C717.482 97.1253 721.292 96.0515 724.45 94.633C727.335 93.2544 730.376 91.299 732.544 89.0678C738.853 82.5848 730.307 81.4021 724.92 81.4493C723.423 81.4747 720.746 81.6016 719.19 81.6778C700.548 82.6138 682.025 86.151 665.681 95.1191C654.804 100.945 644.634 108.517 632.308 112.087C620.116 115.671 606.391 116.408 594.819 110.12C592.192 108.687 589.774 106.888 587.705 104.987C584.091 101.696 581.239 97.7421 578.62 94.2194C576.963 92.0572 571.637 82.817 564.684 88.803C562.047 91.0704 560.593 95.4202 558.972 98.2971C552.106 111.292 540.57 120.881 527.577 127.251C517.764 132.098 507.441 135.722 496.863 138.487C474.403 144.248 435.949 147.644 418.956 128.539C408.903 117.155 408.75 99.9224 416.359 87.2793C419.703 81.4493 425.855 76.3594 431.665 73.3301C437.311 70.3008 442.96 68.5957 448.759 66.8289C457.953 63.7525 467.704 63.2809 476.075 61.3907C481.488 60.1246 487.975 56.1775 489.199 54.5703C490.234 53.2099 491.687 50.6123 490.521 48.3413C489.997 47.3182 488.31 46.56 488.088 46.5092C484.212 45.5805 481.011 45.6712 476.417 45.9033C465.81 46.6434 454.959 48.8709 444.301 51.0586C426.485 54.7191 384.151 80.6366 358.093 91.3643C347.999 95.7467 336.915 99.2259 326.089 101.82C298.952 108.651 269.822 110.12 242.307 102.6C228.224 99.1098 217.038 92.2168 205.553 83.8546C202.792 81.8774 199.783 79.6535 197 77.9048C194.043 76.0329 190.418 74.2842 187.355 73.2684C177.928 70.0686 171.408 72.1293 164.104 78.6522C162.141 80.4262 160.906 81.8338 158.466 84.0577C146.482 95.2715 130.465 101.312 114.919 105.139C101.689 108.666 87.2356 109.841 73.6562 106.402C55.7238 102.099 41.3321 90.5153 30.8852 75.8224C28.0368 71.9007 0 13.9345 0 13.9345C3.82469 12.1097 7.79143 10.7275 11.8857 9.7697C23.6548 6.96898 36.2143 7.91948 47.5645 11.8884C49.1345 12.4652 50.6935 13.1799 52.1796 13.9418C60.838 18.346 67.8608 26.1641 73.7545 32.7741C76.8106 36.1407 81.6734 42.2791 85.3087 42.9321C92.4117 44.2055 102.702 39.823 105.321 37.7769C109.288 34.6751 113.233 30.006 114.569 28.6347C124.892 18.034 137.831 9.28356 152.343 4.45849C181.017 -5.37669 212.926 1.8573 237.298 18.4439C243.876 22.7502 250.273 28.2864 256.778 32.5346C257.591 33.0788 258.844 33.7681 259.667 34.1744L259.973 34.276L260.581 34.4828C260.989 34.6207 261.394 34.7694 261.802 34.8891C264.191 35.6764 266.73 36.3548 269.178 36.9352C281.635 39.8992 294.676 39.8847 307.41 38.575C317.485 37.4758 327.273 36.0791 337.195 33.3654C358.555 27.6406 380.52 17.6531 403.227 12.8207C410.403 11.3007 490.223 -3.04396 512.912 14.7508L512.919 14.7471Z"
          fill="#FFFFFF" />
      </svg>
      <div class="banner__content">
        <p class="banner__text">
          <span class="banner__title">{{ partnername }} is {{ usePlatformSettings().platformName.value }}!</span>
          {{ $t('partner.partner_notifications') }}
        </p>
        <img
             :src="mascotUrl"
             class="banner__mascot"
             :alt="$t('accessibility.mascot_happy')">
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
defineProps<{ partnername: string }>();
const platformIsBikeable = ref<boolean>(usePlatformSettings().platformName.value === 'bikeable');
import bikeableMascot from '~/assets/bikeable-mascot-happy.svg';
import walkableMascot from '~/assets/walkable-mascot-happy.svg';

const mascotUrl = computed(() => {
  return platformIsBikeable.value
    ? bikeableMascot
    : walkableMascot;
});
</script>
<style lang="scss">
.banner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: -3rem;
  padding: 0 10px;
  height: 160px;

  &__street {
    position: absolute;
    top: 0;
    left: 50%;
    width: 750px;
    margin-left: -350px;
  }

  &__content {
    display: flex;
    max-width: 600px;
    position: relative;
    z-index: 1;
  }

  &__title {
    display: block;
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: .5rem;
  }

  &__text {
    font-size: 1rem;
    line-height: 1.4;
    margin-right: 2rem;
  }

  &__mascot {
    width: 140px;
    height: auto;
    position: relative;
    top: -20px;
  }

  @media screen and (max-width: 639px) {
    height: 140px;
    margin-bottom: -1rem;

    &__street {
      width: 400px;
      margin-left: -200px;
    }

    &__title {
      font-size: 1rem;
    }

    &__text {
      font-size: .875rem;
      margin-right: 1rem;
    }

    &__mascot {
      width: 80px;
    }
  }
}
</style>
